import { createRoot } from 'react-dom/client';
import Root from './root';
import * as Sentry from '@sentry/react';

Sentry.init({
	dsn: 'https://0cc7dc37dd45390368a452e8f82fba11@o4506767709569024.ingest.us.sentry.io/4509614992457728',
	sendDefaultPii: true, // Include IP address and other user identifiers

	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
		Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })
	],

	// Tracing: capture 100% of transactions (adjust in production)
	tracesSampleRate: 1.0,

	// Session Replay configuration
	replaysSessionSampleRate: 0.1, // Capture 10% of sessions
	replaysOnErrorSampleRate: 1.0, // Always capture sessions with errors

	environment: process.env.NODE_ENV || 'development',

	_experiments: {
		enableLogs: true // Enable Sentry's structured logging
	}
});

// ✅ Structured logging and test error
const { logger } = Sentry;
logger.info('React app is starting...', { env: process.env.NODE_ENV });
// Sentry.captureException(new Error('🧪 Test startup exception'));

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(<Root />);
